export class FaixaDescargaCIF {
  id: number;
  de: number;
  ate: number;
  valor: number;
}
